<script setup lang="ts">
import { NewProduct, NewProductModification } from '@/types/api/api-v4/product'
import { ProductParentType } from '@/types/components/product-card.types'

import AppMeasureUnits from '@/components/App/AppMeasureUnits.vue'
import ProductTagExtra from '@/components/Product/ProductTags/ProductTagExtra.vue'

type Props = {
  product: NewProduct
  currentModification: NewProductModification
}

const props = defineProps<Props>()

const productTitle = computed(() => {
  if (props.product.modifications.length >= 2) {
    return `${props.product.name}`
  }

  return props.product.modifications[0].mode
    ? `${props.product.name}: ${props.product.modifications[0].mode}`
    : `${props.product.name}`
})
</script>

<template>
  <div class="product-detail-header">
    <span class="product-detail-header__title">{{ productTitle }}</span>

    <product-tag-extra
      class="product-detail-header__extra"
      :main-tags="product.main_tags"
      :additional-tags="product.additional_tags"
      :type="ProductParentType.detail"
    />

    <app-measure-units
      class="product-detail-header__weight"
      :weight="currentModification.weight"
      :volume-in-liters="currentModification.volume_in_liters"
      :measure="currentModification.measure"
    />
  </div>
</template>

<style scoped lang="scss">
.product-detail-header {
  &__title {
    font-size: 18px;
    font-weight: 800;
    line-height: 23px;
    color: var(--ui-secondary);
    word-break: break-word;

    @include media('>=tablet') {
      font-size: 22px;
      line-height: 29px;
    }
  }

  &__extra {
    margin-left: 4px;

    @include media('>=desktop-mini') {
      margin-left: 8px;
    }
  }

  &__weight {
    margin-left: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    color: var(--ui-dark-grey);

    @include media('>=desktop-mini') {
      margin-left: 8px;
    }
  }
}
</style>
